<script setup>
import { ref, onMounted } from 'vue';

const deferredPrompt = ref(null);
const showInstallPrompt = ref(false);

onMounted(() => {
  if (localStorage.getItem('pwaInstallDeclined') !== 'true') {
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      deferredPrompt.value = e;
      showInstallPrompt.value = true;
    });
  }
});

const installPWA = async () => {
  if (deferredPrompt.value) {
    deferredPrompt.value.prompt();
    const {outcome} = await deferredPrompt.value.userChoice;
    deferredPrompt.value = null;
    showInstallPrompt.value = false;
  }
};

const declineInstall = () => {
  localStorage.setItem('pwaInstallDeclined', 'true');
  showInstallPrompt.value = false;
};
</script>

<template>
  <div v-if="showInstallPrompt" class="install-banner">
    <div class="container-xl d-flex align-items-center justify-content-between py-2">
      <div class="d-flex align-items-center">
        <span class="icon-tabler icon-tabler-device-mobile me-2"></span>
        <span>{{ __DICT__.installPrompt}}</span>
      </div>
      <div class="d-flex">
        <button @click="declineInstall" class="btn btn-sm btn-ghost-secondary me-2">
          {{ __DICT__.doNotInstall}}
        </button>
        <button @click="installPWA" class="btn btn-sm btn-primary">
          {{ __DICT__.install }}
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.install-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: var(--tblr-body-bg);
  border-top: 1px solid var(--tblr-border-color);
  box-shadow: 0 -2px 10px rgba(var(--tblr-body-color-rgb), 0.1);
  z-index: 9999;
}
</style>